import { useSyncExternalStore } from 'react';

const state = {
  byId: new Map(),   // id -> ticket object
  ids: [],           // visible ids for the current page
};

let listeners = new Set();

function emit() {
  for (const l of listeners) l();
}

function subscribe(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function useTicketIds() {
  return useSyncExternalStore(subscribe, () => state.ids);
}

export function useTicketById(id) {
  return useSyncExternalStore(subscribe, () => state.byId.get(id));
}

export function replacePage(tickets) {
  state.byId.clear();
  for (const t of tickets) {
    state.byId.set(t.id, t);
  }
  state.ids = tickets.map(t => t.id);
  emit();
}

export function setPageIds(ids) {
  state.ids = ids.slice();
  emit();
}

export function upsertTicket(ticket) {
  const prev = state.byId.get(ticket.id) || {};
  state.byId.set(ticket.id, { ...prev, ...ticket });
  // If the id wasn't present but should appear, the caller should also call setPageIds/addTicketId.
  emit();
}

export function removeTicket(id) {
  if (state.byId.has(id)) {
    state.byId.delete(id);
  }
  const idx = state.ids.indexOf(id);
  if (idx !== -1) {
    const next = state.ids.slice();
    next.splice(idx, 1);
    state.ids = next;
  }
  emit();
}

export function addTicketIdIfMissing(id) {
  if (!state.ids.includes(id)) {
    state.ids = state.ids.concat(id);
    emit();
  }
}

export function clearStore() {
  state.byId.clear();
  state.ids = [];
  emit();
}
